import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { HighIssues } from "@/features/oversight/components/high-issues"
import { RiskMoved } from "@/features/risk/components/risk-moved"
import { RiskStanding } from "@/features/risk/components/risk-standing"
import { issueQueries } from "@/queries/issues"
import { riskQueries } from "@/queries/risk"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/oversight/"
)({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(riskQueries.network()),
      context.queryClient.ensureQueryData(
        issueQueries.list({ open: true, severity: "high" })
      ),
    ]),
  component: OversightPage,
})

function OversightPage() {
  return (
    <>
      <PageHeader title="Oversight" />
      <div className="flex flex-col gap-10">
        <RiskStanding />
        <HighIssues />
        <RiskMoved />
      </div>
    </>
  )
}
